import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  Icon,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'

export const MultipleBoxesDeliveryMessage = () => (
  <Box paddingV={2} paddingBottom={0}>
    <Box
      bg={Color.Informative_50}
      borderRadius={1}
      display={Display.Flex}
      alignItems={AlignItems.FlexStart}
      gap={2}
      paddingH={3}
      paddingV={2}
      maxWidth={['100%', '100%', '50%']}
    >
      <Box color={Color.Informative_700} display={Display.Flex}>
        <Icon name="info" size={6} variant={IconVariant.Inherit} />
      </Box>
      <Text size={4}>
        Heads up, your order could arrive in 1 or 2 boxes. We&apos;ll let you know when it&apos;s
        packed.
      </Text>
    </Box>
  </Box>
)
